import React from "react";

const SocialButtons = ({ href, icon }) => {
  return (
    <a
      href={href}
      className="inline-block p-4 text-lg text-center h-14 w-14 border-primary text-darkTheme-accent-primary hover:text-xl"
    >
      <div className="leading-[3.5rem] align-middle">{icon}</div>
    </a>
  );
};

export default SocialButtons;
